<template>
  <div class="smsc-container">
    <vx-card>
      <div slot="no-body" class="flex flex-wrap items-center justify-between pl-3 pr-3">
        <div class="buttons-container flex flex-wrap items-center justify-start pb-3">
          <vs-button
            class="mt-3"
            @click="$router.push({ name: 'Company_admin_DIDs_list' })"
          >Back to DID</vs-button>
        </div>
        <div class="buttons-container flex flex-wrap items-center justify-end pb-3">
          <vs-button
            color="danger"
            class="mt-3 mr-3 mr-md-0"
            @click="$router.push({ name: 'Company_admin_DIDs_list' })"
          >Cancel</vs-button>
          <vs-button
            class="mt-3"
            @click="editDid()"
          >Save DID</vs-button>
        </div>
      </div>
    </vx-card>
    <vx-card>
      <div slot="no-body" class="p-3">
        <smsc-col>
          <smsc-col-item col-quantity="3" mt="0">
            <vs-input
              v-validate="'required'"
              class="w-100 deep"
              :class="{'is-danger': errors.has('PHONE NUMBER')}"
              name="PHONE NUMBER"
              label="PHONE NUMBER"
              placeholder="Enter Phone number"
              v-model="did.did"
            />
            <span class="text-danger text-xs">{{ errors.first('PHONE NUMBER') }}</span>
          </smsc-col-item>

          <smsc-col-item col-quantity="3" mt="0">
            <label class="vs-input--label">LOCATION</label>
            <v-select
              v-validate="'required'"
              data-vv-validate-on="input"
              name="Location"
              placeholder="Enter Location"
              :class="{'is-danger': errors.has('Location')}"
              label="name"
              :reduce="(option) => option.value"
              :options="countrys"
              v-model="did.location_company_uuid"
            />
            <span v-if="errors.has('Location')" class="text-danger text-xs">{{ errors.first('Location') }}</span>
          </smsc-col-item>

          <smsc-col-item col-quantity="3" mt="0">
            <vs-input
              data-vv-validate-on="input"
              class="w-100 deep"
              name="Price"
              label="PRICE"
              placeholder="Enter Price"
              v-model="did.price"
            />
<!--            <span   :class="{'is-danger': errors.has('Price')}" class="text-danger text-xs">{{ errors.first('Price') }}</span>-->
          </smsc-col-item>

          <smsc-col-item  col-quantity="3" mt="0">
            <label class="vs-input--label">MONTH</label>
            <v-select
              v-validate="'required'"
              class="deep"
              name="Month"
              placeholder="Enter Month"
              :class="{'is-danger': errors.has('Month')}"
              :options="month"

              v-model="selected"
            />
            <span class="text-danger text-xs">{{ errors.first('Month') }}</span>
          </smsc-col-item>

          <smsc-col-item  col-quantity="3" mt="0">
            <label class="vs-input--label">COMPANY</label>
            <v-select
              v-validate="'required'"
              data-vv-validate-on="input"
              class="deep"
              name="Company"
              label="name"
              placeholder="Enter Company"
              :class="{'is-danger': errors.has('Company')}"
              :options="allcompanies"
              :reduce="(option) => option.value"
              v-model="did.company_uuid"
            />
            <span class="text-danger text-xs">{{ errors.first('Company') }}</span>
          </smsc-col-item>
        </smsc-col>



      </div>
    </vx-card>
  </div>
</template>


<script>
  import vSelect from "vue-select";

  export default {
    name: "Edit",
    components: {
      vSelect
    },
    data: () => ({
      contactError: null,
      month: ["per hour", "per day", "per month"],
      role: ["per hour", "per day", "per month"],
      contact: null,
      newDid: {
        price: null,
        did: null,
        location_company_uuid: null,
        company_uuid: null,
      },

      countrys: [],
      allcompanies: [],
      did: [],
      selected: null,
      amount: null,
    }),
    watch: {
      selected: function () {
        if (!this.did.using) {
          this.amount = "";
        } else {
          this.amount =
            this.selected === "per month"
              ? this.did.using.max_sms_per_month
              : this.selected === "per day"
              ? this.did.using.max_sms_per_day
              : this.did.using.max_sms_per_hour;
        }
      },
    },
    methods: {
      getCountrys() {
        this.$store.dispatch("didcompany/getCountryList", {}).then(res => {
          // console.log(res,"this.res")
          this.countrys = res.items/*.map(this.TransformCompany)*/
          // console.log(this.countrys,"this.countrys")
        })
      },
      getAllCompanies() {
        this.$store
          .dispatch("didcompany/GetCompanyList", {
            page: this.Page,
            search: this.SearchCompany,
          })
          .then((res) => {
            // console.log("res111--->", res);
            this.allcompanies = res.items.map(this.TransformCompany); // .map(this.transformCompanies);
            // console.log("this.allcompanies--->", this.allcompanies);

          });
      },
      getDid() {
        console.log("this.$route.params.did,", this.$route.params.id);
        this.$store.dispatch("didcompany/GetSearchedDid", this.$route.params.id)
          .then((res) => {
            // console.log("res GetSearchedDid--->", res);
            this.did = res;
          });
      },
      editDid() {
        this.$validator.validate().then((result) => {
          if (result) {
            this.newDid.country_uuid = this.did.location_company_uuid;
            this.newDid.company_uuid = this.did.company_uuid;
            this.newDid.did = this.did.did;
            this.newDid.price = this.did.price;
            this.$store
              .dispatch("didcompany/EditDid", {
                did: this.$route.params.id,
                newDid: this.newDid,
              })
              .then(() => {
                this.$snotify.success("DID have beed edited.", {
                  timeout: 6000,
                });
                this.$router.push({ name: "company-admin-dids" });
              })
              .catch((err) => {
                if (err.errors) {
                  this.contactError = err.errors[0].contact
                    ? err.errors[0].contact
                    : null;
                  setTimeout(() => {
                    this.contactError = null;
                  }, 6000);
                } else {
                  this.$snotify.error(err.error.message, {
                    timeout: 6000,
                  });
                }
              });
          }
        });
      },
      TransformCompany(item) {
        return {
          name: item.company_name,
          value: item.company_uuid
        }
      }
    },

    created() {
      this.getDid();
      this.getAllCompanies();
      this.getCountrys();
    },
    /*created() {
      this.uuid = this.$route.query['edit_product_uuid']
      this.GetList()
    },
    methods:{
      GetList() {
        this.$vs.loading()
        this.$store.dispatch('product/GetList', {
          product_uuid:this.uuid,


        })
          .then(res => {
            this.payload = res.items[0]

          })
          .catch()
          .finally(() => {
            this.$vs.loading.close()
          })
      },
      Save(){
        let params = {
          id : this.uuid,
          data:{
            product_name : this.payload.product_name,
            status : this.payload.status,
            public : this.payload.public
          }

        }
        this.$store.dispatch('product/Edit',params).then(()=>{
          this.$router.push({ name: 'Admin-product' })
          this.ShowSuccessMessage({ title: 'Success', text: 'Edit Product has been added' })
        }).catch(()=>{
          this.ShowErrorMessage({ title: 'Error'})
        }).finally(()=>{

        })
      },
      // Notify
      ShowSuccessMessage ({ title, text }) {
        this.$vs.notify({
          iconPack: 'feather',
          icon: 'icon-check',
          color: 'success',
          title,
          text
        })
      },
      ShowErrorMessage ({ title, text }) {
        this.$vs.notify({
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          title,
          text
        })
      },
    },*/
  }
</script>

<style lang="scss" scoped>
  .upload-form {
    display: flex;
    flex-wrap: wrap;
    width: 100%;

    .upload-form__item {
      flex-grow: 1;
      min-width: 270px;
      padding: 10px;

      &.first {

      }
      &.second {

      }
    }
  }

  .deep-upload /deep/ .con-input-upload{
    margin: 0;
    padding: 0!important;
  }
  .deep-upload /deep/ .con-img-upload{
    padding: 0!important;
  }
  @media (min-width: 601px) {
    .margin-top-content{
      margin-top: 18px;
    }

  }
</style>
